import { pickingSystem } from './picking.config';
import { Constants as Base } from './base.config';
import { Constants as Customer } from './customer.config';
import { Constants as Order } from './order.config';
import { Constants as Entity } from './entity.config';
import { Constants as ReasonPrint } from './reasonPrint.config';
import { Constants as Dispatch } from './dispatch.config';
import { Constants as quotation } from './quotation.config';
import { statusPicking } from './statusOfPicking';
import { SaleConfig } from './sale.config';
import { ReportConfig } from './report.config';
import { ModificationType } from './report.config';
import { ConfigQuotation } from './state-quotation.config';
import { ConfigUser } from './user.config';
import { Company } from './company.config';
import { SaleNote } from './sale-note-config';
import { statusDispatch } from './state-dispatches.config';
import { tripStatus } from './trip-status.config';
import { CAPACITY } from './capacity.config';
import { measurableProduct } from './measurable-product.config';
import { OriginType } from './origin-type';
import { SETTING_TEMP } from './setting-temp.config';
import { DASHBOARD_PROPERTIES, GRAPHIC_TITLE, EMBED_REPORTS } from './dashboard.config';
import { SALE_ENTERPRISE } from './sale-enterprise.config';
import { pickingReportConfig } from './picking-report.config';
import { lotStates } from './lots.config';
import { DISPATCH_STATES, DISPATCH_STATUS_LIST } from './dispatch-states.config';
import { tripMode } from './trip-mode.config';
import { routeConfig } from './route.config';
import { StyleConfig } from './styles.config';
import { ExchangeConfig } from './exchange.config';
import { saleChannel } from './saleChanel.config';
import { SaleNoteStatusConfig, SaleNotePaymentStatusConfig } from './sale-note-status.config';
import { WEIGHABLE_REASON } from './measurable-product.config';
import { guideState } from './guide.config';
import { hierarchyLevels } from './hierarchy-level.config';
import { DESPACHO_DOMICILIO, RETIRO_TIENDA } from '../../shared/components/data-table/data-table-config/configuration';
export const Constants = {
  Base,
  Customer,
  Order,
  Entity,
  statusPicking,
  SaleConfig,
  ReasonPrint,
  Dispatch,
  ReportConfig,
  ModificationType,
  ConfigQuotation,
  ConfigUser,
  Company,
  SaleNote,
  statusDispatch,
  quotation,
  pickingSystem,
  tripStatus,
  measurableProduct,
  OriginType,
  CAPACITY,
  SETTING_TEMP,
  SALE_ENTERPRISE,
  GRAPHIC_TITLE,
  DASHBOARD_PROPERTIES,
  pickingReportConfig,
  lotStates,
  DISPATCH_STATES,
  tripMode,
  routeConfig,
  DISPATCH_STATUS_LIST,
  StyleConfig,
  EMBED_REPORTS,
  ExchangeConfig,
  saleChannel,
  SaleNoteStatusConfig,
  SaleNotePaymentStatusConfig,
  WEIGHABLE_REASON,
  guideState,
  hierarchyLevels,
  DESPACHO_DOMICILIO,
  RETIRO_TIENDA
};
